<template>
  <div>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <loadingcomp
      ref="loadingcomp"
      v-bind:mesaj="loadingmesaj"
      v-model="loadingdialog"
    ></loadingcomp>
    <v-flex xs12 sm12 md12>
      <v-card flat color="grey-lighten-4">
        <v-layout row wrap>
          <v-flex xs12 sm12 md5 pa-3>
            <v-card pa-2 style="min-height: 230px">
              <v-layout row wrap align-center pl-3 pb-4>
                <v-flex xs12 sm12 md6>
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs8 sm10 md9>
                        <pnrbul v-model="val.PNR_No" hide-details> </pnrbul>
                      </v-flex>
                      <v-flex xs4 sm2 md2>
                        <v-btn
                          color="blue-grey"
                          @click="getOdeme()"
                          class="white--text"
                          fab
                          dark
                          small
                        >
                          <v-icon>search</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <tarihim
                    :etiket="$t('Payment-Date')"
                    :detaygizle="true"
                    v-model="val.OdemeTarihi"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-bind:defaultvalue="'ok'"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-text-field
                    hide-details=""
                    :label="$t('Exchange-Rate-v2')"
                    v-model="val.Kur"
                  ></v-text-field>
                  <v-select
                    hide-details=""
                    dense
                    :items="doviztipi"
                    @input="getKur()"
                    item-text="Title"
                    item-value="DovizKod"
                    :label="$t('Currency-Unit')"
                    v-model="val.ParaBirimi"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm12 md6 v-if="!odemeTipShow">
                  <cariaracomp
                    hide-details=""
                    v-bind:etiket="$t('Select-Counter-Current')"
                    :rules="false"
                    v-bind:value="val.NakitBilgi.KarsiCari.kod"
                    v-model="val.NakitBilgi.KarsiCari.kod"
                  ></cariaracomp>
                </v-flex>
                <v-flex xs12 sm12 md6 v-if="!odemeTipShow">
                  <v-text-field
                    hide-details=""
                    :label="this.$t('Counter-Current')"
                    v-model="val.NakitBilgi.KarsiCariAciklama"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md6 v-if="odemeTipShow">
                  <v-text-field
                    hide-details=""
                    :label="$t('Transfer-Bank')"
                    v-model="val.HavaleBilgi.Banka"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md6 v-if="odemeTipShow">
                  <v-text-field
                    hide-details=""
                    :label="$t('Transfer-Explanation')"
                    v-model="val.HavaleBilgi.Aciklama"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    hide-details=""
                    :label="$t('Description')"
                    v-model="val.Aciklama"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 sm12 md2 pa-3>
            <v-card style="min-height: 230px">
              <v-layout row wrap align-center pl-3>
                <v-radio-group
                  hide-details=""
                  :mandatory="false"
                  v-model="val.OdemeTipi"
                  @change="odemeTipiChange(val.OdemeTipi)"
                >
                  <template v-slot:label>
                    <span class="title"> {{ $t("Payment-Type") }} </span>
                  </template>
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap="">
                      <v-flex
                        v-for="(item, index) in itemsOdemeTip"
                        v-bind:key="index"
                        xs12
                        pa-2
                        sm12
                        md12
                      >
                        <v-radio :label="item.text" v-bind:value="item.value">
                        </v-radio>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-radio-group>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 sm12 md5 pa-3>
            <v-card style="min-height: 230px">
              <v-layout row wrap align-center pl-3 pb-4>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    :disabled="odemeKartShow"
                    :label="$t('Card-No')"
                    hide-details=""
                    v-model="val.KrediKartBilgi.KartNo"
                  ></v-text-field>

                  <v-autocomplete
                    :disabled="odemeKartShow"
                    :items="bankapositems"
                    @change="taksitgetirservis(val.KrediKartBilgi.Banka)"
                    v-model="val.KrediKartBilgi.Banka"
                    item-text="Title"
                    item-value="PosKodu"
                    clearable
                    hide-details=""
                    :label="$t('Bank')"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-select
                    :disabled="odemeKartShow"
                    dense
                    :items="itemsKartTipi"
                    item-text="text"
                    hide-details=""
                    item-value="value"
                    v-model="val.KrediKartBilgi.KartTipi"
                    label="Tip"
                  ></v-select>
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6>
                        <v-checkbox
                          :label="$t('Refund')"
                          v-model="val.OdemeIadesi"
                          hide-details=""
                        ></v-checkbox>
                      </v-flex>

                      <v-flex xs12 sm12 md6>
                        <v-text-field
                          hide-details=""
                          :label="$t('Document-No')"
                          v-model="val.EvrakNo"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-select
                    :disabled="odemeKartShow"
                    :items="taksitsayiservis"
                    v-model="val.KrediKartBilgi.Taksit"
                    item-text="TaksitAciklama"
                    item-value="TaksitAdet"
                    clearable
                    hide-details=""
                    :label="$t('Instalment')"
                  >
                  </v-select>

                  <parainput
                    :simge="getparabirimi()"
                    :etiket="$t('Payment-Amount')"
                    :isPositive="true"
                    v-model="val.Tutar"
                    :autocomplete="'autocomplete'"
                  ></parainput>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <v-flex v-for="(item, index) in odemeList" :key="index" pa-3 xs12 sm12 md12>
      <v-hover>
        <v-card
          width="100%"
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2}`"
          class="elevation-1 pa-3"
        >
          <v-layout row wrap align-center justify-end>
            <v-flex xs12 sm6 md2>
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm12 md6 style="color: #67768f"
                      >{{ $t("Document-No") }}:</v-flex
                    >
                    <v-flex xs6 sm12 md6>{{ item.evrakNo }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm12 md6 style="color: #67768f"
                      >{{ $t("Document-Type") }}:</v-flex
                    >
                    <v-flex xs6 sm12 md6>{{ item.evrakTipi }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm12 md6 style="color: #67768f"
                      >{{ $t("Date") }} :</v-flex
                    >
                    <v-flex xs6 sm12 md6>{{ item.tarih }}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm6 md2>
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm12 md6 style="color: #67768f"
                      >{{ $t("Currency-Amount") }}:</v-flex
                    >
                    <v-flex xs62 sm12 md6>{{ item.dovizTutar }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm12 md6 style="color: #67768f">
                      {{ $t("Currency-Exchange-Rate") }} :</v-flex
                    >
                    <v-flex xs6 sm12 md6>{{ item.para.kur }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm12 md6 style="color: #67768f"
                      >{{ $t("Currency-Unit") }}:</v-flex
                    >
                    <v-flex xs6 sm12 md6>{{ item.para.paraBirimi }}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm6 md2>
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm12 md6 style="color: #67768f">
                      {{ $t("Card-Bank") }} :</v-flex
                    >
                    <v-flex xs6 sm12 md6>{{ item.kartBanka }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm12 md6 style="color: #67768f"
                      >{{ $t("Card-Type-v2") }}:</v-flex
                    >
                    <v-flex xs6 sm12 md6>{{ item.kartTip }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap> &nbsp; </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm6 md2>
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm12 md6 style="color: #67768f">
                      {{ $t("Card-instalment") }} :</v-flex
                    >
                    <v-flex xs6 sm12 md6>{{ item.kartTaksit }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm12 md6 style="color: #67768f">
                      {{ $t("Card-No") }}:</v-flex
                    >
                    <v-flex xs6 sm12 md6>{{ item.kartNo }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  &nbsp;
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm12 md3>
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md6 style="color: #67768f"
                      >(H.V. Banka / Krş Cari):</v-flex
                    >
                    <v-flex xs12 sm12 md6
                      >{{ item.hvBankaKod }} {{ item.hesapKodu }}</v-flex
                    >
                  </v-layout>
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md6 style="color: #67768f"
                      >Karşı Cari Açıklama:</v-flex
                    >
                    <v-flex xs12 sm12 md6>&nbsp;</v-flex>
                  </v-layout>
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md6 style="color: #67768f"
                      >{{ $t("Description") }}:</v-flex
                    >
                    <v-flex xs12 sm12 md6>{{ item.hvAciklama }}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm12 md1>
              <v-btn color="error" fab small @click="GenelOdemeSil(item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-hover>
    </v-flex>
  </div>
</template>

<script>
import auth from "../../../../api/auth";
import tool from "../../coper/tools";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import parainput from "@/components/app/customcomp/parainput.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";

export default {
  props: ["value", "pnrNo"],
  data() {
    return {
      toplamIskonto: 0,
      checkSatisTip: 0,
      odemeList: [],
      doviztipi: [],
      kurList: [],
      kayitTarihi: null,
      tahsilatList: [],
      itemsOdemeTip: [
        {
          text: this.$t("Cash"),
          value: 0,
        },
        {
          text: this.$t("Credit-Card"),
          value: 1,
        },
        {
          text: this.$t("Transfer-v3"),
          value: 2,
        },
        {
          text: "Sanal Pos",
          value: 3,
        },
      ],
      loadingmesaj: "Vize",
      loadingdialog: false,
      text1: "",
      snackbar: false,
      odemeTipShow: false,
      odemeKartShow: true,
      bankapositems: [],
      taksitsayiservis: [],
      servistaksitsayi: "",
      itemsKartTipi: [
        {
          text: "VISA",
          value: 0,
        },
        {
          text: "MASTER",
          value: 1,
        },
        {
          text: "AmEx",
          value: 2,
        },
      ],
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
    };
  },
  computed: {
    val: {
      get: function () {
        this.odenecekTutar = 0.0;
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  components: {
    tarihim,
    cariaracomp,
    parainput,
    snackbarcomp,
    loadingcomp,
    pnrbul,
    yetkidialog,
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth("coper-pnrodeme");

    if (this.sayfayetki.Status == true) {
      this.getOdeme();
      this.kurTipi = "TL";
      this.val.TakipNo = this.takipNo;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CompanyCode: credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.doviztipi = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );

      this.$http
        .post(auth.API_URL + "api/BankPos/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.bankapositems = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-bankpos";
              this.progress = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-bankpos";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  methods: {
    getparabirimi() {
      return helpers.getparabirimi();
    },
    GenelOdemeSil(val) {
      if (this.sayfayetki.Save) {
        this.loadingdialog = true;
        var prm = {
          P_SirketAdi: val.sirketAdi,
          P_HesapKodu: val.hesapKodu,
          P_Tarih: val.tarih,
          P_SiraNo: val.siraNo,
        };
        tool.http_post(this, "GenelOdemeSil", prm).then(
          (response) => {
            this.loadingdialog = false;
            this.getOdeme();
          },
          (response) => {
            this.loadingdialog = false;
            this.status = tool.responseToStatus(response);
          }
        );
      } else {
        this.snackbar = true;
        this.text1 =
          "Coper Pnr Tahsilat Sayfası için Silme yetkiniz bulunmamaktadır.";
      }
    },
    addOdeme() {
      if (this.sayfayetki.Save) {
        this.loadingdialog = true;
        this.loadingmesaj = this.$t("Payment");
        tool.http_post(this, "OdemeKaydet", this.val).then(
          (response) => {
            this.getOdeme();
            this.loadingdialog = false;
          },
          (response) => {
            this.loadingdialog = false;
            this.status = tool.responseToStatus(response);
          }
        );
      } else {
        this.snackbar = true;
        this.text1 =
          "Coper Pnr Tahsilat Sayfası için Kayıt yetkiniz bulunmamaktadır.";
      }
    },
    getOdeme() {
      if (this.pnrNo != 0 && this.pnrNo != null) {
        this.val.PNR_No = this.pnrNo;
      }
      if (this.val.PNR_No != null || this.pnrNo != null) {
        this.toplamIskonto = 0;
        this.odemeList = [];
        let prm = {
          pNR_No: this.val.PNR_No,
          hedefParaBirimi: "TL",
          kurTarihi: tool.Now_yyyy_MM_dd(),
        };

        tool.http_post(this, "GetOdeme", prm).then(
          (response) => {
            if (response.body.data.length > 0) {
              this.odemeList = response.body.data;

              response.body.data.forEach((element) => {
                this.toplamIskonto += element.iskonto;
              });
            } else {
              this.snackbar = true;
              this.text1 = this.$t("No-Records-Found");
            }
          },
          (response) => {
            this.HataYonetimi(response, prm, "Ödeme Getirilemedi");
          }
        );
      }
    },
    odemeTipiChange(val) {
      if (val == 2) {
        this.odemeKartShow = true;
        this.odemeTipShow = true;
        this.val.HavaleBilgi.Aciklama = null;
        this.val.HavaleBilgi.Banka = null;
      } else {
        if (val == 0) {
          this.odemeKartShow = true;
        } else {
          this.odemeKartShow = false;
          this.val.NakitBilgi.KarsiCari.kod = null;
          this.val.NakitBilgi.KarsiCariAciklama = null;
          this.odemeTipShow = false;
        }
      }
      this.val.KrediKartBilgi.KartNo = null;
      this.val.KrediKartBilgi.KartTipi = null;
      this.val.KrediKartBilgi.KartAdi = null;
      this.val.KrediKartBilgi.Banka = null;
      this.val.KrediKartBilgi.Taksit = null;
      this.val.KrediKartBilgi.PosKodu = null;
      this.val.KrediKartBilgi.PosTaksit = null;
    },
    getKur() {
      if (this.kurList.length == 0) {
        if (this.kayitTarihi == null) {
          this.kayitTarihi = tool.Now_yyyy_MM_dd();
        }
        tool
          .http_post(this, "KurAra", {
            tarih: this.kayitTarihi,
          })
          .then(
            (response) => {
              this.kurList = response.body;
              this.selectKur(this.kurTipi);
            },
            (response) => {
              this.val.Kur = 1;
            }
          );
      } else {
        this.selectKur(this.kurTipi);
      }
    },
    paraAraNew(paraBirimi) {
      return paraBirimi.paraBirimi == this.val.ParaBirimi;
    },
    paraAraOld(paraBirimi) {
      return paraBirimi.paraBirimi == this.kurTipi;
    },
    selectKur() {
      var newVal = this.kurList.find(this.paraAraNew);
      var oldVal = this.kurList.find(this.paraAraOld);

      if (newVal == undefined) {
        this.val.Kur = 1;
        newVal = {
          kur: 1,
        };
      } else {
        this.val.Kur = newVal.kur;
      }

      if (oldVal == undefined) {
        oldVal = {
          kur: 1,
        };
      }

      // if (oldVal.kur != newVal.kur) {
      //   this.topKalanToplam = this.calculateCurrency(
      //     this.topKalanToplam,
      //     oldVal.kur,
      //     newVal.kur
      //   );
      //   this.topOdenenToplam = this.calculateCurrency(
      //     this.topOdenenToplam,
      //     oldVal.kur,
      //     newVal.kur
      //   );
      //   this.topTutarToplam = this.calculateCurrency(
      //     this.topTutarToplam,
      //     oldVal.kur,
      //     newVal.kur
      //   );
      // }
      this.kurTipi = this.val.ParaBirimi;
    },
    taksitgetirservis(v) {
      var tumliste = [];
      tumliste = this.bankapositems;

      tumliste.forEach((element) => {
        if (element.PosKodu == v) {
          this.taksitsayiservis = [];
          this.taksitsayiservis = element.Taksitler;
        }
        this.val.KrediKartBilgi.Taksit = parseInt(this.servistaksitsayi);
      });
    },
  },
  filters: {
    gettime: function (t) {
      return helpers.getTime(t);
    },
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    timeformat: function (c) {
      return helpers.timeformat(c);
    },
  },
};
</script>

<style>
</style>